import { Routes } from '@angular/router';

import { authRoutes } from '../core/auth/auth.routes';
import { DefaultLayoutComponent } from '../core/default-layout/default-layout.component';
import { dashboardRoutes } from '../pages/dashboard/dashboard.routes';
import { lessonRoutes } from '../pages/lesson/lesson.routes';
import { studentRoutes } from '../pages/student/student.routes';
import { uxRoutes } from '../pages/ux/ux.routes';
import { exerciseRoutes } from '../pages/exercise/exercise.routes';
import { IsAuthorizedGuard } from './isAuthorized.guard';
import { AuthGuard } from '../../guards/auth.guard';

/**
 * If user is not logged in then we show the Auth Layout (doesn't include navbar)
 * In other case, DefaultLayoutComponent is rendered (including navbar and other core components)
 *
 * @type {[any,{path: string; component: DefaultLayoutComponent; children: [any]}]}
 */
export const routes: Routes = [
  ...authRoutes,
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [IsAuthorizedGuard, AuthGuard],
    children: [
      // Component from pages folder
      ...dashboardRoutes,
      ...lessonRoutes,
      ...studentRoutes,
      ...exerciseRoutes,
      ...uxRoutes,
    ]
  }
];
